import { useEffect } from 'react';
import { useRustyState } from '@/state';

export const RETENTION_DAYS = [1, 7, 14, 30, 60, 90, 180, 365, 730] as const;

// Free and pay-as-you-go keep 30 days; it is also the answer while the plan is unknown.
const FREE_MAX_RETENTION = 30;

/** The plan's "Keep messages for" maximum and the choices up to it. */
export function usePlanRetention(): { max: number; options: number[] } {
  const plans = useRustyState((s) => s.subscriptionPlans);
  const subscription = useRustyState((s) => s.currentSubscription);

  useEffect(() => {
    const state = useRustyState.getState();
    if (!state.subscriptionPlans?.length) {
      void state.getAndSetSubscriptionPlans().catch(() => undefined);
    }
  }, []);

  const plan = subscription ? plans?.find((p) => p.id === subscription.plan_id) : undefined;
  const planMax = plan ? plan.max_retention_days : FREE_MAX_RETENTION;
  const max = planMax ?? RETENTION_DAYS[RETENTION_DAYS.length - 1];
  return { max, options: RETENTION_DAYS.filter((d) => d <= max) };
}
